import React from 'react';
import Layout from '../components/Layout'

if (typeof window !== `undefined`  && window.location.pathname=='/') window.location.replace(`/blog`) // highlight-line

//Conteúdo da página inicial ainda em branco. TO-DO: criar um conteúdo de página inicial
export default function Index() {
    return <Layout></Layout>
}